import React from "react";

import { Controls } from "@common/treeToggle";
import { Filters } from "./filters";
import { Sort } from "./sort";
import { ViewsSelector } from "./viewsSelector";
import { CreationMenu } from "./creationMenu";
import { MoveToTodayButton } from "./moveToTodayButton";
import { Props } from "./types";
import styles from "./styles.scss";

function Header({
  project,
  ganttLength,
  filter,
  sort,
  moveToToday,
  setSort,
  setFilter,
  reset,
}: Props) {
  return (
    <div className={styles.header} style={{ zIndex: ganttLength + 1 }}>
      <div className={styles.firstLine}>
        <div className={styles.selectors}>
          <Sort sort={sort} select={setSort} />
          <div className={styles.filters}>
            <Filters filter={filter} setFilter={setFilter} reset={reset} />
          </div>
          <ViewsSelector />
          <MoveToTodayButton move={moveToToday} />
        </div>
        <div className={styles.creationMenu}>
          {project && <CreationMenu project={project} />}
        </div>
      </div>
    </div>
  );
}

export { Header };
